import * as React from 'react';
import ContentModal from '../components/content-modal';
import InfographicsIcon from '../../assets/images/infographics-icon-white.png';
import styled from 'styled-components/native';
import config from './config';
import FrequentlyAskedQuestions from '../../components/education/faq/questions';
import Infographics from '../../components/education/infographics';

const Screen = styled(ContentModal)`
  position: absolute;
  top: ${config.modals.top}px;
  right: 15px;
  width: 33vw;
`;

export default function InfographicsScreen() {
  return (
    <Screen title="Infographics" icon={InfographicsIcon}>
      <Infographics />
    </Screen>
  );
}
